export default "9b4baa7dae56c179b7f848cb26dbe69d.svg";